import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const FALLBACK = [
  { id: "_def_salario", name: "Salario", type: "income", icon: "Briefcase", color: "#10B981", is_default: true },
  { id: "_def_freelance", name: "Freelance", type: "income", icon: "Sparkles", color: "#38BDF8", is_default: true },
  { id: "_def_inv", name: "Inversión", type: "income", icon: "TrendingUp", color: "#22D3EE", is_default: true },
  { id: "_def_comida", name: "Comida", type: "expense", icon: "UtensilsCrossed", color: "#F59E0B", is_default: true },
  { id: "_def_transporte", name: "Transporte", type: "expense", icon: "Car", color: "#8B5CF6", is_default: true },
  { id: "_def_entret", name: "Entretenimiento", type: "expense", icon: "Music", color: "#F43F5E", is_default: true },
  { id: "_def_serv", name: "Servicios", type: "expense", icon: "Plug", color: "#3B82F6", is_default: true },
  { id: "_def_compras", name: "Compras", type: "expense", icon: "ShoppingBag", color: "#EC4899", is_default: true },
  { id: "_def_salud", name: "Salud", type: "expense", icon: "Heart", color: "#EF4444", is_default: true },
  { id: "_def_edu", name: "Educación", type: "expense", icon: "GraduationCap", color: "#A78BFA", is_default: true },
  { id: "_def_otros", name: "Otros", type: "expense", icon: "MoreHorizontal", color: "#94A3B8", is_default: true },
];

export function useCategories() {
  const [categories, setCategories] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/categories");
      // Backend returns objects with {id, name, type, color, icon}
      // Map to {value, ...} shape used across existing UI
      const mapped = (data || []).map(c => ({
        ...c,
        value: c.name,
      }));
      if (mapped.length > 0) {
        setCategories(mapped);
      }
    } catch {
      // keep fallback
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const colorOf = useCallback((name) => {
    const c = categories.find(x => x.name === name || x.value === name);
    return c?.color || "#8B5CF6";
  }, [categories]);

  return { categories, loading, reload: load, colorOf };
}
